if (!customElements.get('shopping-guide-navigation')) {
  class ShoppingGuideNavigation extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('[data-guide-nav-link]'));
      this.categories = Array.from(this.querySelectorAll('[data-guide-category]'));

      this.links.forEach((link) => {
        link.addEventListener('click', this.handleLinkClick);
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersect, {
          rootMargin: '-20% 0px -65% 0px',
          threshold: 0
        });
        this.categories.forEach((category) => this.observer.observe(category));
      }
    }

    disconnectedCallback() {
      this.links?.forEach((link) => {
        link.removeEventListener('click', this.handleLinkClick);
      });
      this.observer?.disconnect();
    }

    handleLinkClick = (event) => {
      const categoryNumber = event.currentTarget.dataset.guideNavLink;
      const category = this.querySelector(`[data-guide-category="${categoryNumber}"]`);

      if (category && !category.open) category.open = true;
      this.setActiveLink(categoryNumber);
    };

    handleIntersect = (entries) => {
      const visibleEntry = entries.find((entry) => entry.isIntersecting);
      if (!visibleEntry) return;

      this.setActiveLink(visibleEntry.target.dataset.guideCategory);
    };

    setActiveLink(categoryNumber) {
      this.links.forEach((link) => {
        const isActive = link.dataset.guideNavLink === categoryNumber;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('shopping-guide-navigation', ShoppingGuideNavigation);
}
